module.exports = __webpack_public_path__ + "static/img/function-box-img6.4f66cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img6.png
// module id = HfDl
// module chunks = 0